import { mergeWith } from "lodash";
import { objectGetAt } from "./objectGetAt";
import { pathCreateObject, pathUp, pathEnd, updateArray, Messages } from "./useDataStoreMiro";

export function applyMessagesToData<dataTypes>(messages: Messages<dataTypes>, data: any) {
    let newPathObjects;
    newPathObjects = messagesToPathObjects<dataTypes>(messages, data);

    for (const n of newPathObjects) {
        data = mergeWith(data, n, customOverwriteArrays);
    }
    return data
}

function customOverwriteArrays(objValue: any, srcValue: any, key: string, object: any, source: any) {
    if (Array.isArray(srcValue)) {
        return srcValue
    }
}

export function messagesToPathObjects<dataTypes>(messages: Messages<dataTypes>, originalData: any) {
    const newPathObjects = [];
    if (!Array.isArray(messages))
        messages = [messages];

    for (const message of messages) {
        let { path, data, index, remove, ids } = message;

        if (!Array.isArray(path))
            path = path.split('.');


        if (remove) {
            const newParent = pathCreateObject(pathUp(path));
            console.log("newParent", newParent)
            const originalParent = objectGetAt(pathUp(path), originalData);

            if (originalParent._order) { // Also delete it from _order if it is a list item
                newParent._order = originalParent._order.filter((e: any) => {
                    return e !== pathEnd(path);
                });
            }

            newParent[pathEnd(path)] = null;
            console.log("newParent", newParent)
            const newParentPathObject = pathCreateObject(pathUp(path), newParent);
            console.log("newParentPathObject", newParentPathObject)
            //await miro.board.setAppData(mergedDataKey, newParentPathObject)
            newPathObjects.push(newParentPathObject);
        } else {
            let originalObject = objectGetAt(path, originalData);

            //TODO: Fix for Miro issue turning empty arrays into objects then remove this
            if (Object.hasOwn(message, "index") && !Array.isArray(originalObject))
                originalObject = [];

            if (ids) {
                const newPathObject = pathCreateObject(path, data);
                let order = objectGetAt([...path, '_order'], originalData);
                if (!Array.isArray(order))
                    order = []; //TODO: Correct issue when Miro looses arrays

                updateArray(index, order, ids, true);
                // @ts-ignore
                data._order = order;
                //await miro.board.setAppData(mergedDataKey, newPathObject)
                newPathObjects.push(newPathObject);
            } else if (Array.isArray(originalObject)) {
                // first remove the existing element if it exists
                const dataJson = JSON.stringify(data);
                const newArray = originalObject.filter(e => JSON.stringify(e) !== dataJson);
                // Insert the new one
                updateArray(index, newArray, data);
                // Add it to the partial
                const newPathObject = pathCreateObject(path, newArray);
                //await miro.board.setAppData(mergedDataKey, newPathObject)
                newPathObjects.push(newPathObject);
            } else {
                const newPathObject = pathCreateObject(path, data);
                //await miro.board.setAppData(mergedDataKey, newPathObject)
                newPathObjects.push(newPathObject);
            }
        }
    }
    return newPathObjects;
}

